const footLinks = [
  { label: "最新进展", href: "#timeline" },
  { label: "追踪事件榜", href: "#board" },
  { label: "吃瓜分舱", href: "#channels" },
  { label: "存档速查", href: "#archive" },
  { label: "追更入口", href: "#entry" },
];

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-12">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                <i className="ri-article-line text-base"></i>
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-display text-lg font-extrabold text-foreground-950">九色黑料</span>
                <span className="text-[10px] font-medium text-secondary-600">吃瓜第一现场</span>
              </span>
            </a>
            <p className="mt-3 text-xs leading-relaxed text-secondary-600">
              一个聚合公开信息、按时间线整理爆料与进展的吃瓜速递站。本站仅作信息汇总与脉络梳理，
              各方观点并排列出，供你自行对照判断。
            </p>
          </div>

          <div className="flex flex-col gap-4 sm:flex-row sm:gap-12">
            <div>
              <p className="mb-3 text-xs font-semibold text-secondary-700">快速前往</p>
              <ul className="grid grid-cols-2 gap-x-6 gap-y-2">
                {footLinks.map((l) => (
                  <li key={l.href}>
                    <a href={l.href} className="text-xs text-foreground-600 hover:text-foreground-950">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="mb-3 text-xs font-semibold text-secondary-700">内容分区</p>
              <ul className="space-y-2">
                <li><a href="#channels" className="text-xs text-foreground-600 hover:text-foreground-950">人物线</a></li>
                <li><a href="#channels" className="text-xs text-foreground-600 hover:text-foreground-950">商业线</a></li>
                <li><a href="#channels" className="text-xs text-foreground-600 hover:text-foreground-950">实锤速递</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-5 sm:flex-row">
          <p className="text-xs text-secondary-500">
            © {new Date().getFullYear()} 九色黑料 · 吃瓜第一现场。仅供公开信息汇总参考。
          </p>
          <div className="flex items-center gap-2 text-secondary-500">
            <span className="inline-flex items-center gap-1">
              <i className="ri-eye-line"></i>
              今日围观 186w
            </span>
            <span className="h-3 w-px bg-background-300"></span>
            <a href="#top" className="text-xs hover:text-foreground-950">
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}